<template>
  <v-list-item >
    <v-list-item-avatar class="mt-1">
      <template v-if="item.avatar">
        <img :src="item.avatar">
      </template>
      <template v-else>
        <v-icon large color="grey"> {{icon}} </v-icon>
      </template>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title> {{item.email}} </v-list-item-title>
      <v-list-item-subtitle>
        <span>{{rol(item.role_id)}}</span>
        <br />
        <span class="main grey white--text" v-if="item.is_admin">WEHELP ADMIN</span>
        <span class=" main primary white--text" v-if="item.confirmed">CUENTA CONFIRMADA</span>
        <span class=" main orange dark-2 white--text" v-else>NO CONFIRMADO</span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <!-- <v-list-item-action>
      <v-btn icon ripple @click="$emit('detalle', item)">
        <v-icon color="grey lighten-1">info</v-icon>
      </v-btn>
    </v-list-item-action> -->
  </v-list-item>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
    icon: {
      type: String
    },
  },
  methods: {
    rol(id) {
      const roles = this.$store.getters['provider/roles']
      const rol = roles.find(sel => sel.id === id)
      if (rol) {
        return rol.text
      } else {
        return '---'
      }
    }
  }
}
</script>
<style scoped>
.main {
  padding:0 7px;
  border-radius: 25px;
  margin-right: 5px;
  font-size:11px;
}
</style>

